module.exports = __webpack_public_path__ + "static/media/GIF-prueba.9f66c9c1.gif";